import { MessageCircle } from 'lucide-react'
import PetAnimationController from './PetAnimationController.jsx'

function PetCompanion({
  bubbleTone = 'default',
  className = '',
  label,
  level,
  manifest,
  message,
  name,
  onClick,
  onPointerDown,
  onPointerUp,
  open = false,
  paused = false,
  state,
  title,
}) {
  return (
    <div
      className={[
        'pet-companion',
        open ? 'is-open' : '',
        className,
      ].filter(Boolean).join(' ')}
    >
      {message && (
        <span
          aria-live="polite"
          className={`pet-companion-bubble ${bubbleTone === 'drop' ? 'is-drop' : ''}`}
        >
          {message}
        </span>
      )}
      <button
        aria-expanded={open}
        aria-label={label}
        className="pet-companion-button"
        onClick={onClick}
        onPointerDown={onPointerDown}
        onPointerUp={onPointerUp}
        title={title}
        type="button"
      >
        <span className="pet-companion-stage">
          <PetAnimationController manifest={manifest} paused={paused} state={state} />
        </span>
        <span className="pet-companion-meta">
          <span className="pet-companion-name">{name}</span>
          {level ? <span className="pet-companion-level">Lv.{level}</span> : null}
        </span>
        <span className="pet-companion-chat" aria-hidden="true">
          <MessageCircle size={15} />
        </span>
      </button>
    </div>
  )
}

export default PetCompanion
